export default __webpack_public_path__ + "static/media/Girotti.8bde8227.jpg";